export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  OTP_VERIFICATION: '/otp-verification',

  // Protected routes
  DASHBOARD: '/dashboard',
  MARKETERS: '/marketers',
  MARKETERS_DETAIL_LIST: '/marketers/:id',
  MARKETERS_EARNINGS_BONUSES: '/marketers/:id/earnings-bonuses',
  MARKETERS_EDIT_PERSONAL: '/marketers/:id/edit-personal',
  MARKETERS_EDIT_BANK: '/marketers/:id/edit-bank',
  MARKETERS_EDIT_PARTITA_IVA: '/marketers/:id/edit-partita-iva',
  MARKETERS_EDIT_CODICE_FISCALE: '/marketers/:id/edit-codice-fiscale',
  MERCHANTS: '/merchants',
  MERCHANTS_DETAIL: '/merchants/:id',
  MERCHANTS_EDIT_BILLING: '/merchants/:id/edit-billing',
  MERCHANTS_EDIT_BUSINESS_OWNER: '/merchants/:id/edit-business-owner',
  MERCHANTS_EDIT_BUSINESS_DETAILS: '/merchants/:id/edit-business-details',
  SHOPPERS: '/shoppers',
  SHOPPERS_DETAIL: '/shoppers/:id',
  SHOPPERS_EARNINGS_BONUSES: '/shoppers/:id/earnings-bonuses',
  SHOPPERS_EDIT_PERSONAL: '/shoppers/:id/edit-personal',
  SHOPPERS_EDIT_BANK: '/shoppers/:id/edit-bank',
  SHOPPERS_EDIT_CODICE_FISCALE: '/shoppers/:id/edit-codice-fiscale',
  SHOPPER_PAYOUT: '/shopper-payout',
  SHOPPER_PAYOUT_IMPORT: '/shopper-payout/import',
  SHOPPER_PAYOUT_DETAIL: '/shopper-payout/:id',
  TOPUP_CASHBACK: '/topup-cashback',
  ONE_SNAP: '/transactions/1-snap',
  ONE_SNAP_DETAIL: '/transactions/1-snap/:id',
  REVERSAL: '/transactions/reversal',
  REVERSAL_DETAIL: '/transactions/reversal/:id',
  PURCHASES: '/purchases',
  MANUAL_PURCHASE: '/purchases/create',
  MANUAL_PURCHASE_DETAIL: '/purchases/:id',
  ROLES: '/roles',

  // User Management
  USERS: '/users',
  USER_CREATE: '/users/create',
  USER_EDIT: '/users/:id/edit',
  USER_PROFILE: '/users/:id',

  // Content Management
  CONTENT: '/content',
  POSTS: '/content/posts',
  POST_CREATE: '/content/posts/create',
  POST_EDIT: '/content/posts/:id/edit',
  CATEGORIES: '/content/categories',
  MEDIA: '/content/media',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_SECURITY: '/settings/security',
  SETTINGS_NOTIFICATIONS: '/settings/notifications',
  SETTINGS_INTEGRATIONS: '/settings/integrations',

  // Profile
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',

  // Analytics
  ANALYTICS: '/analytics',
  REPORTS: '/reports',

  // Audit
  AUDIT_LOGS: '/audit/logs',

  // Error pages
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/401',
  SERVER_ERROR: '/500',

  // Helper function to generate dynamic routes
  generatePath: (route, params = {}) => {
    let path = route;
    Object.keys(params).forEach(key => {
      path = path.replace(`:${key}`, params[key]);
    });
    return path;
  },
};
